<template>
    <van-popup
        v-if="workOrderUserReplacePopupShow"
        :value="workOrderUserReplacePopupShow"
        z-index="100"
        :close-on-click-overlay="false"
        :style="{ height: '100vh', width: '100vw', background: 'rgba(0,0,0,.3)' }"
        overlay-class="custom_popup"
        position="right"
    >
        <div class="public_container add_approval_wrap">
            <div class="returnNavBar">
                <ReturnNavBar
                    title="返回"
                    :isCustomReturnEvent="true"
                    :isTitleNormal="true"
                    :isAllFunctions="true"
                    @returnEvent="handleClickClose"
                ></ReturnNavBar>
            </div>
            <div class="work_order_add_container mobile_container custom_mobile_form" v-loading="loading">
                <van-form
                    label-width="9.5em"
                    input-align="right"
                    scroll-to-error
                    :show-error-message="false"
                    :rules="workOrderProcessingUserReplaceFormRules"
                    ref="workOrderProcessingUserReplaceForm"
                    class=""
                >
                    <van-field
                        v-model="workOrderProcessingUserReplaceForm.old_processing_uid_text"
                        name="old_processing_uid"
                        label="原实施人员"
                        placeholder="请选择"
                        error-message-align="right"
                        is-link
                        readonly
                        @click="handleClickProcessingUidsFieldlink('old_processing_uid')"
                    >
                    </van-field>
                    <van-field
                        v-model="workOrderProcessingUserReplaceForm.new_processing_uid_text"
                        name="new_processing_uid"
                        label="更改为"
                        placeholder="请选择"
                        error-message-align="right"
                        is-link
                        readonly
                        @click="handleClickProcessingUidsFieldlink('new_processing_uid')"
                    >
                    </van-field>
                </van-form>
            </div>
            <div class="add_footer_wrap mobile_add_footer_wrap">
                <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm"
                    >确定</van-button
                >
            </div>
            <!-- 实施人员选择 -->
            <UserSelect
                :userSelectVisible.sync="userSelectVisible"
                :userSelectTitle="'选择实施人员'"
                :allUserList="currentProcessingUserList"
                @selectUserData="handleSelectUserData"
                v-if="userSelectVisible"
            />
        </div>
    </van-popup>
</template>
<script>
import { roleDetail, replaceProcessingUid } from "@/api";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import UserSelect from "./component/user_select.vue";
export default {
    name: "WorkOrderProcessingUserReplace",
    components: { ReturnNavBar, UserSelect },
    props: {
        workOrderUserReplacePopupShow: {
            type: Boolean,
            default: false,
        },
        workorder_id: "",
        processingUserSelectedList: {
            type: Array,
            default: () => [],
        }, // 现在已经分配的实施人员数据
    },
    data() {
        return {
            loading: false,
            workOrderProcessingUserReplaceForm: {
                old_processing_uid: "",
                old_processing_uid_text: "",
                new_processing_uid: "",
                new_processing_uid_text: "",
            },
            workOrderProcessingUserReplaceFormRules: {},

            processingUserList: [], // 可选择的实施人员
            currentProcessingUserList: [], // 当前选择的

            nowField: "",
            userSelectVisible: false,

            btnDisabled: false,
        };
    },
    created() {
        this.getRoleDetail();
    },
    methods: {
        handleClickClose() {
            this.$emit("update:workOrderUserReplacePopupShow", false);
        },
        // 获取在工单实施角色中设置的范围内选择人员
        getRoleDetail() {
            roleDetail({
                role_type: "processing_user",
            }).then((res) => {
                if (res.code === 200) {
                    const data = res.data || [];
                    const selectedUids = this.processingUserSelectedList.map((item) => item.id);
                    // 从实施角色中的全部未被选择人员中选择，排除掉当前工单已经选择过的
                    const processingUserList = data.filter((item) => !selectedUids.includes(item.id));
                    this.processingUserList = processingUserList;
                }
            });
        },
        handleClickProcessingUidsFieldlink(field) {
            this.nowField = field;
            if (field === "old_processing_uid") {
                // 选择原实施人员
                this.currentProcessingUserList = JSON.parse(JSON.stringify(this.processingUserSelectedList));
            } else {
                // 替换人员选择
                this.currentProcessingUserList = JSON.parse(JSON.stringify(this.processingUserList));
            }
            this.userSelectVisible = true;
        },
        // 选择实施人员确认
        handleSelectUserData(data) {
            if (this.nowField === "old_processing_uid") {
                this.$set(this.workOrderProcessingUserReplaceForm, "old_processing_uid", data.id);
                this.$set(this.workOrderProcessingUserReplaceForm, "old_processing_uid_text", data.name);
            } else {
                this.$set(this.workOrderProcessingUserReplaceForm, "new_processing_uid", data.id);
                this.$set(this.workOrderProcessingUserReplaceForm, "new_processing_uid_text", data.name);
            }
        },
        handleClickConfirm() {
            this.$refs.workOrderProcessingUserReplaceForm.validate().then(() => {
                const params = {
                    workorder_id: this.workorder_id,
                    old_processing_uid: this.workOrderProcessingUserReplaceForm.old_processing_uid,
                    new_processing_uid: this.workOrderProcessingUserReplaceForm.new_processing_uid,
                };
                if (!params.old_processing_uid || !params.new_processing_uid) return;
                this.btnDisabled = true;
                replaceProcessingUid(params)
                    .then((res) => {
                        if (res.code === 200) {
                            this.$toast({
                                message: res.message,
                                type: "success",
                                duration: 1000,
                                onClose: () => {
                                    this.btnDisabled = false;
                                    this.$emit("update:workOrderUserReplacePopupShow", false);
                                    this.$emit("replaceSuccess");
                                },
                            });
                        } else {
                            this.btnDisabled = false;
                        }
                    })
                    .catch(() => {
                        this.btnDisabled = false;
                    });
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.mobile_container {
    width: 100%;
    padding: 10px 0;
    box-sizing: border-box;
}
</style>
